module.exports = __webpack_public_path__ + "static/media/manovr-3.36e8df49.jpg";